import { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "components/layout/PageLayout";
import { useRequireResetMutation, useUpdatePasswordMutation, useValidateOtpMutation } from "./api/restoreApiSlice";


export default function RestorePassword() {

    const [email, setEmail] = useState()
    const [otp, setOtp] = useState()
    const [pwd, setPwd] = useState()
    const [wizardStatus, setWizardStatus] = useState("START")

    const [requestReset, {
        isLoading,
        isSuccess: resetRequestIsSuccess,
        isError: resetRequestError,
        reset: resetRequestReset
    }] = useRequireResetMutation()

    const [verifyOtp, {
        isLoading: otpValidationLoading,
        isSuccess: otpValidationSuccess,
        isError: otpValidationError,
        reset: resetOtpVerify
    }] = useValidateOtpMutation()

    const [updatePassword, {
        isLoading: updatePasswordLoading,
        isSuccess: updatePasswordSuccess,
        isError: updatePasswordError
    }] = useUpdatePasswordMutation()

    const handleVerifyEmail = async (e) => {

        e.preventDefault()
        console.log("Emai: " + email)
        requestReset(email)
    }

    const handleVerifyOtpCode = async (e) => {

        e.preventDefault()
        console.log("Verifing OTP for: " + email)
        verifyOtp({
            email: email,
            otp: otp
        })
    }

    const handleUpdatePassword = async (e) => {

        e.preventDefault()
        console.log("Update pwd for: " + email)
        updatePassword({
            email: email,
            otp: otp,
            pwd: pwd
        })
    }

    function resetWizard() {
        resetRequestReset()
        resetOtpVerify()
    }



    return <PageLayout
        pageTitle={"Restore Password"}
        isLoadingContent={isLoading || otpValidationLoading || updatePasswordLoading}
        bodyContent={<>

            <div className="col-lg-5"  >
                <div className="card bg-dark text-white mb-5">
                    <div className="card-header">

                        {
                            !resetRequestIsSuccess && !resetRequestError &&
                            <form onSubmit={handleVerifyEmail}>
                                <h5>Your email</h5>
                                <p>Inserisci la tua email per recuperare la password</p>
                                <div className="mb-3">
                                    <input className="form-control" type="email" name="email" required onChange={(e) => setEmail(e.target.value)} />

                                </div>
                                <button className="btn btn-primary" type="submit">Invia</button><br />
                                <div className="mt-3">
                                    <Link to="/login">Torna al login</Link>
                                </div>
                            </form>
                        }

                        {
                            resetRequestError &&
                            <>
                                <h3 className="text-danger">Wrong Email!</h3>
                                <div className="mb-3">
                                    <p> Somenthing is wrong, please check your email and retry</p>
                                </div>
                                <button className="btn btn-primary" onClick={resetWizard}>Retry</button>

                            </>
                        }

                        {
                            resetRequestIsSuccess && !otpValidationSuccess && !otpValidationError &&

                            <form onSubmit={handleVerifyOtpCode}>
                                <h5> <i className="fa-solid fa-key"></i> OTP code sent</h5>
                                <p>We sent an OTP code to your email:<br />

                                    <span className="text-eh">{email}</span>
                                </p>
                                <div className="mb-3">
                                    <span>Insert OTP:</span>
                                    <input className="form-control" type="text" name="otp" required onChange={(e) => setOtp(e.target.value)} />
                                </div>
                                <button className="btn btn-primary" type="submit" >Valida</button>
                            </form>
                        }

                        {
                            otpValidationError &&
                            <>
                                <h3 className="text-danger">Wrong OTP!</h3>
                                <div className="mb-3">
                                    <p> Somenthing is wrong, please check your email and retry</p>
                                </div>
                                <button className="btn btn-primary" onClick={resetWizard}>Retry</button>

                            </>
                        }

                        {
                            otpValidationSuccess && !updatePasswordSuccess &&

                            <form onSubmit={handleUpdatePassword}>
                                <h3><i className="fa-solid fa-circle-check text-success"></i> Valid OTP!</h3>
                                <div className="mb-3">
                                    <p>Insert new password</p>
                                    <input className="form-control" type="password" name="password" required onChange={(e) => setPwd(e.target.value)} />
                                </div>
                                <button className="btn btn-primary" type="submit">Conferma</button>
                            </form>
                        }

                        {
                            updatePasswordSuccess &&
                            <>
                                <h3 className="text-success"><i className="fa-solid fa-circle-check"></i> Success</h3>
                                <div className="mb-3">
                                    <p>Your password has been successfully updated</p>
                                </div>
                                <Link to="/login"><button className="btn btn-primary">Login</button></Link>
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
        }
    />



}